module.exports = __webpack_public_path__ + "components/country-flag/static/af-8ebd5c046de2571dfd35c7e8533528ed.svg";